import { render } from "./LangIcon.vue?vue&type=template&id=2fd82267&scoped=true"
import script from "./LangIcon.vue?vue&type=script&lang=js"
export * from "./LangIcon.vue?vue&type=script&lang=js"

import "./LangIcon.vue?vue&type=style&index=0&id=2fd82267&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd82267"],['__file',"src/Components/ChatWidget/ChatIcons/LangIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2fd82267"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2fd82267', __exports__)) {
    api.reload('2fd82267', __exports__)
  }
  
  module.hot.accept("./LangIcon.vue?vue&type=template&id=2fd82267&scoped=true", () => {
    api.rerender('2fd82267', render)
  })

}


export default __exports__